import angular from 'angular'

/**
 * @description Set focus on the next tabindex when current maxlength's input reached
 * Already check if there are only number on input
 *
 * @param maxlength Maximum length for each input
 * @param tabindex Index of all chained inputs
 **/
/* @ngInject */
const next = () => {
  return {
    require: 'ngModel',
    scope: {
      ngModel: '=',
    },
    link: (scope, element, attrs, ctrl) => {
      element.on('input', (e) => {
        if ('' + element.val().length === '' + element.attr('maxlength')) {
          const indextab = parseInt(attrs.indextab)
          const next = angular.element(document.body).find('[indextab=' + (indextab + 1) + ']')

          if (next.length) {
            next[0].focus()
          }
        }
        scope.ngModel = element.val()
      })

      scope.$on('$destroy', () => { element.off() })

      ctrl.$validators.match = (modelValue, viewValue) => {
        if (modelValue !== undefined && modelValue !== null) {
          viewValue = viewValue.replace(/[^0-9]/g, '')
          element.val(viewValue)
          scope.ngModel = element.val()
          // if ('' + element.val().length === '' + element.attr('maxlength')) {
          //   return true
          // }
          // return false
        }
        return true
      }
    },
  }
}

/* @ngInject */
const nextRevision = () => {
  return {
    require: 'ngModel',
    scope: {
      ngModel: '=',
    },
    link: (scope, element, attrs, ctrl) => {
      element.on('input', (e) => {
        if ('' + element.val().length === '' + element.attr('maxlength')) {
          const nextelement = parseInt(attrs.nextelement)
          const next = angular.element(document.body).find('[nextelement=' + (nextelement + 1) + ']')

          if (next.length) {
            next[0].focus()
          }
        }
        scope.ngModel = element.val()
      })

      scope.$on('$destroy', () => { element.off() })
    },
  }
}

export default {
  'next': next,
  'nextRevision': nextRevision,
}



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/inputs/next.js